import React from "react";
import { Input, Row, Typography, Form, Card, Col } from "antd";
import appLabel from "../../../../../config/appLabel";

const { Text } = Typography;

export default function DetailsForm({ casaDetail }) {
  const [useForm] = Form.useForm();

  return (
    <Form layout="vertical" form={useForm}>
      <Card
        style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          padding: 10,
        }}
      >
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.productName}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail.name}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.shortName}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail.shortName}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.description}</Text>}>
              <Input.TextArea
                className="of-bold-disable-input"
                disabled
                value={casaDetail.description}
              ></Input.TextArea>
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Form>
  );
}
